import { useCallback, type MouseEventHandler } from "react";

import type { InputMethod } from "@/game/input";

export function getActivationInputMethod(
  event: Pick<MouseEvent, "detail">
): InputMethod {
  return event.detail === 0 ? "keyboard" : "pointer";
}

export function useAccessibleActivation<TElement extends HTMLElement>(
  onActivate: (inputMethod: InputMethod) => void,
  disabled = false
): MouseEventHandler<TElement> {
  return useCallback(
    (event) => {
      if (disabled) {
        return;
      }

      onActivate(getActivationInputMethod(event.nativeEvent));
    },
    [disabled, onActivate]
  );
}
